import styled from 'styled-components';

import { BadgeTone } from 'utils/profileBadges';

const TONE_PALETTE: Record<
  BadgeTone,
  { bg: string; fg: string; border: string }
> = {
  gold: { bg: '#FEF3C7', fg: '#92400E', border: '#FDE68A' },
  purple: { bg: '#EDE9FE', fg: '#5B21B6', border: '#DDD6FE' },
  green: { bg: '#D1FAE5', fg: '#065F46', border: '#A7F3D0' },
  blue: { bg: '#DBEAFE', fg: '#1E40AF', border: '#BFDBFE' },
};

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin-top: ${({ theme }) => theme.spacing.sm};
`;

export const Pill = styled.span<{ $tone: BadgeTone }>`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.9rem;
  border-radius: 999rem;
  font-size: 1.15rem;
  font-weight: 700;
  background-color: ${({ $tone }) => TONE_PALETTE[$tone].bg};
  color: ${({ $tone }) => TONE_PALETTE[$tone].fg};
  border: 0.1rem solid ${({ $tone }) => TONE_PALETTE[$tone].border};
  letter-spacing: 0.02rem;
`;

export const Label = styled.span``;
